import { create } from 'zustand'
import zustyMiddleware from 'zustymiddlewarets'


interface T_BecomeShareholderStore {
  isBecomeShareholderStep1DrawerVisible: boolean
  showBecomeShareholderStep1Drawer: () => void
  hideBecomeShareholderStep1Drawer: () => void

  isBecomeShareholderStep2DrawerVisible: boolean
  showBecomeShareholderStep2Drawer: () => void
  hideBecomeShareholderStep2Drawer: () => void

  isBecomeShareholderStep3DrawerVisible: boolean
  showBecomeShareholderStep3Drawer: () => void
  hideBecomeShareholderStep3Drawer: () => void
}

export const useBecomeShareholderStore = create<
  T_BecomeShareholderStore
>()(zustyMiddleware((set) => ({

  //
  // Step 1
  //

  isBecomeShareholderStep1DrawerVisible: false,

  showBecomeShareholderStep1Drawer: () => {
    set({ isBecomeShareholderStep1DrawerVisible: true })
  },

  hideBecomeShareholderStep1Drawer: () => {
    set({ isBecomeShareholderStep1DrawerVisible: false })
  },


  //
  // Step 2
  //

  isBecomeShareholderStep2DrawerVisible: false,

  showBecomeShareholderStep2Drawer: () => {
    set({ isBecomeShareholderStep2DrawerVisible: true })
  },

  hideBecomeShareholderStep2Drawer: () => {
    set({ isBecomeShareholderStep2DrawerVisible: false })
  },


  //
  // Step 3
  //

  isBecomeShareholderStep3DrawerVisible: false,

  showBecomeShareholderStep3Drawer: () => {
    set({ isBecomeShareholderStep3DrawerVisible: true })
  },

  hideBecomeShareholderStep3Drawer: () => {
    set({ isBecomeShareholderStep3DrawerVisible: false })
  },

})))
